import { NgModule } from '@angular/core';
import { FiCompareHtmlService } from './compare-html.service';

@NgModule({
    providers: [FiCompareHtmlService],
})
export class CompareHtmlModule {}
